import { useVariant } from '@calendly/feature-check-react';
import { I18n } from '@calendly/i18n';
import { DollarSign } from '@calendly/ui/components/icons';
import { primaryColor } from '@calendly/ui/theme';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { moveToChangeSubscription } from 'actions/billing/subscription_modal';
import { ANALYTICS_PAYWALL_SHOWN_PROPS_MAP } from 'components/empty_state/constants';
import { featureTierSelector, setAnalyticsLocation, useRetrialOfferEligibility, checkTrialExtensionEligibility } from 'features/billing';
import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events';
import { useTrack } from 'hooks/analytics_events/useTrack';
import { Banner } from './banner';
const styledIconCss = "syqjmks";
const StyledIcon = forwardRef((props, ref) => {
  const color = primaryColor;
  return <DollarSign ref={ref} {...props} color={color} className={classNames(styledIconCss, props.className)} />;
});
export const AdminBanner = ({
  featureKey,
  contentKey
}) => {
  const dispatch = useDispatch();
  const track = useTrack();
  const requiredTier = useSelector(state => featureTierSelector(state, {
    featureKey
  }));
  const growthRetrialsModalVariation = useVariant('growth_paywall_retrials', false);
  const isEligibleForRetrial = useRetrialOfferEligibility();
  const showUpgradeModal = () => {
    dispatch(setAnalyticsLocation('admin_center_managed_workflows'));
    dispatch(moveToChangeSubscription({
      featureKey
    }));
    const properties = ANALYTICS_PAYWALL_SHOWN_PROPS_MAP('popup')[contentKey] || ANALYTICS_PAYWALL_SHOWN_PROPS_MAP('popup')[featureKey];
    if (!properties) return;
    if (growthRetrialsModalVariation === 'variant' && isEligibleForRetrial) return;
    track({
      name: TRACKING_EVENT_NAMES.PAYWALL_SHOWN,
      properties
    });
  };
  useEffect(() => {
    dispatch(checkTrialExtensionEligibility());
  }, [dispatch]);
  return <Banner Icon={StyledIcon} text={I18n.t('publisher.upgrade_banner.admin_text', {
    plan: requiredTier
  })} onClick={showUpgradeModal} buttonText={I18n.t('publisher.upgrade_banner.button_text', {
    plan: requiredTier
  })} />;
};

require("./admin_banner.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./admin_banner.js");